import { useEffect, useRef, useState } from "react";
import styles from "./VendorStatusDropdown.module.css";

// Dropdown "Sub menu" dua tingkat untuk tab Vendor (desain handoff opsi 2b).
// Kolom kiri: tahap; kolom kanan: sub-grup dari tahap yang sedang di-hover.
const VendorStatusDropdown = ({ stages, stage, group, onChange, children }) => {
  const [open, setOpen] = useState(false);
  const [hover, setHover] = useState(stage);
  const wrapperRef = useRef(null);

  useEffect(() => {
    if (!open) return undefined;

    const closeOnOutsideClick = (e) => {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    const closeOnEscape = (e) => {
      if (e.key === "Escape") {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", closeOnOutsideClick);
    document.addEventListener("keydown", closeOnEscape);

    return () => {
      document.removeEventListener("mousedown", closeOnOutsideClick);
      document.removeEventListener("keydown", closeOnEscape);
    };
  }, [open]);

  const selectedStage = stages.find((s) => s.key === stage);
  const selectedGroup = selectedStage.groups && selectedStage.groups.find((g) => g.key === group);
  const hoveredStage = stages.find((s) => s.key === hover);

  const toggleHandler = () => {
    setHover(stage);
    setOpen(!open);
  };

  // Tahap yang punya sub-grup hanya membuka kolom kanan (perlu untuk layar sentuh)
  const stageClickHandler = (s) => {
    if (s.groups) {
      setHover(s.key);
      return;
    }

    onChange(s.key, null);
    setOpen(false);
  };

  const groupClickHandler = (s, g) => {
    onChange(s.key, g.key);
    setOpen(false);
  };

  return (
    <div className={styles.row}>
      <span className={styles.label}>Sub menu</span>
      <div className={styles.wrapper} ref={wrapperRef}>
        <button
          type="button"
          className={`${styles.trigger} ${open ? styles.triggerOpen : ""}`}
          onClick={toggleHandler}
          aria-haspopup="true"
          aria-expanded={open}
        >
          <span className={styles.triggerText}>
            {selectedGroup ? (
              <>
                <span className={styles.parentText}>{selectedStage.label}</span>
                <span className={styles.separator}>/</span>
                <span className={styles.selectedText}>{selectedGroup.label}</span>
              </>
            ) : (
              <span className={styles.selectedText}>{selectedStage.label}</span>
            )}
          </span>
          <i className={`fa ${open ? "fa-chevron-up" : "fa-chevron-down"} ${styles.chevron}`} />
        </button>

        {open && (
          <div className={styles.panel} role="menu">
            <div className={styles.parents}>
              {stages.map((s) => {
                const isSelected = s.key === stage;
                return (
                  <button
                    key={s.key}
                    type="button"
                    role="menuitem"
                    className={`${styles.item} ${s.key === hover ? styles.itemHover : ""} ${isSelected ? styles.itemSelected : ""}`}
                    onMouseEnter={() => setHover(s.key)}
                    onFocus={() => setHover(s.key)}
                    onClick={() => stageClickHandler(s)}
                  >
                    <span>{s.label}</span>
                    {s.groups && <i className={`fa fa-chevron-right ${styles.itemIcon}`} />}
                    {!s.groups && isSelected && <i className={`fa fa-check ${styles.itemIcon}`} />}
                  </button>
                );
              })}
            </div>

            {hoveredStage.groups && (
              <div className={styles.children}>
                <div className={styles.childrenTitle}>{hoveredStage.label}</div>
                {hoveredStage.groups.map((g) => {
                  const isSelected = hoveredStage.key === stage && g.key === group;
                  return (
                    <button
                      key={g.key}
                      type="button"
                      role="menuitem"
                      className={`${styles.item} ${isSelected ? styles.childSelected : ""}`}
                      onClick={() => groupClickHandler(hoveredStage, g)}
                    >
                      <span>{g.label}</span>
                      {isSelected && <i className={`fa fa-check ${styles.checkIcon}`} />}
                    </button>
                  );
                })}
              </div>
            )}
          </div>
        )}
      </div>

      {/* Slot di kanan dropdown, dipakai untuk tombol Excel All */}
      {children}
    </div>
  );
};

export default VendorStatusDropdown;
